import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoader: false,
  currentSituationLength: 0,
  currentSituation: []
}

export default function currentSituationReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_CURRENT_SITUATION:
      return {...state, loading: action.payload}
    case actions.SAVE_LOADER_CURRENT_SITUATION:
      return {...state, saveLoader: action.payload}
     case actions.GET_CURRENT_SITUATION:
      return {...state, currentSituation: action.payload.currentSituation, currentSituationLength: action.payload.currentSituationLength}
    default:
      return {...state};
  }
}